/* WJW Increment 50 — reposition the EXISTING Judge.me Featured Carousel on
 * zero-product-review mobile PDPs. Never clone reviews, fetch a substitute
 * feed, or change the Judge.me app's content, settings or event handlers.
 */
(() => {
  'use strict';
  if (window.__wjw50JudgeMePlacement) return;
  window.__wjw50JudgeMePlacement = true;
  if (!document.body.classList.contains('template-product')) return;

  const mobile = window.matchMedia('(max-width: 749px)');
  let originalMarker = null;
  let promotedSection = null;
  let poll = null;
  let confirmedHasReviews = false;

  function reviewCount(widget) {
    if (!widget) return null;
    const content = widget.querySelector('.jdgm-rev-widg');
    if (!content) return null;
    // Judge.me's own setup state is authoritative; a placeholder zero during
    // asynchronous initialization must not move the Featured Carousel.
    if (!widget.classList.contains('jdgm--done-setup-widget') &&
        !content.classList.contains('jdgm--done-setup-widget')) return null;
    const count = content.getAttribute('data-number-of-reviews');
    if (count !== null && /^\d+$/.test(count.trim())) return Number(count);
    return null;
  }

  function restore() {
    if (!promotedSection) return;
    promotedSection.classList.remove('wjw50-featured-carousel-promoted');
    if (originalMarker?.parentNode) {
      originalMarker.parentNode.insertBefore(promotedSection, originalMarker);
      originalMarker.remove();
    }
    originalMarker = null;
    promotedSection = null;
  }

  function stop() {
    if (poll !== null) window.clearInterval(poll);
    poll = null;
  }

  function inspect() {
    if (!mobile.matches) { restore(); stop(); return; }
    const widget = document.querySelector('.jdgm-review-widget');
    const count = reviewCount(widget);
    if (count === null) return; // Wait for native Judge.me initialization.
    if (count > 0) { confirmedHasReviews = true; restore(); stop(); return; }
    if (promotedSection) { stop(); return; }

    const productSection = widget.closest('.shopify-section');
    const carousel = document.querySelector('.jdgm-carousel-wrapper');
    const carouselSection = carousel?.closest('.shopify-section');
    if (!productSection || !carouselSection || productSection === carouselSection ||
        !carousel.querySelector('.jdgm-carousel--done') ||
        !carouselSection.parentNode || !productSection.parentNode ||
        productSection.parentNode !== carouselSection.parentNode) return;

    // Leave the original Shopify section exactly where it was unless we have
    // positively confirmed an empty product widget AND an initialized carousel.
    originalMarker = document.createComment('WJW50 Judge.me Featured Carousel original location');
    carouselSection.parentNode.insertBefore(originalMarker, carouselSection);
    productSection.insertAdjacentElement('afterend', carouselSection);
    carouselSection.classList.add('wjw50-featured-carousel-promoted');
    promotedSection = carouselSection;
    stop();
  }

  function start() {
    if (!mobile.matches || poll !== null || confirmedHasReviews) return;
    let attempts = 0;
    inspect();
    if (promotedSection || confirmedHasReviews) return;
    poll = window.setInterval(() => {
      inspect();
      if (++attempts >= 100) stop(); // 30 seconds; no permanent polling.
    }, 300);
  }

  mobile.addEventListener?.('change', () => {
    if (mobile.matches) start();
    else { stop(); restore(); }
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else start();
})();
